import { render, staticRenderFns } from "./bindTest.vue?vue&type=template&id=37db2738"
import script from "./bindTest.vue?vue&type=script&lang=js"
export * from "./bindTest.vue?vue&type=script&lang=js"
import style0 from "./bindTest.vue?vue&type=style&index=0&id=37db2738&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports